export enum CognitoErrorTypes {
    UserExistsException = 'UsernameExistsException',
    NotAuthorizedException = 'NotAuthorizedException',
    UserNotConfirmedException = 'UserNotConfirmedException',
    UserNotFoundException = 'UserNotFoundException',
    InvalidPasswordException = 'InvalidPasswordException',
    InvalidParameterException = 'InvalidParameterException',
    LimitExceededException = 'LimitExceededException',
    PasswordMismatch = 'PasswordMismatch'
}
